import styled from 'styled-components';
import * as mixins from 'view/styles/mixins';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const ButtonGroup = styled.div`
    ${mixins.flexCenter};
    margin-top: ${token('space.200', '16px')};
    justify-content: flex-start;

    > * {
        margin-right: ${token('space.100', '8px')};
    }
`;
